export default {
      id: "oc-monitor-operation-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-monitor-operation",
      toString: function () {
        return this.url;
      }
    }